export default __webpack_public_path__ + "static/banner_works-c9efc34dae20a9a03ebae5bcc8f4a937.png";